<template>
  <div class="lald-case__steps">
    <Step1 v-show="step == 0" @toStep="toStep" @back="back" />
    <Step2 v-show="step == 1" @toStep="toStep" @back="back" />
    <Step3
      v-show="step == 2"
      :visitedSteps="visitedSteps"
      @toStep="toStep"
      @back="back"
    />
    <Step4
      v-show="step == 3"
      :visitedSteps="visitedSteps"
      @toStep="toStep"
      @back="back"
    />
    <Step5 v-show="step == 4" @toStep="toStep" @back="back" />
    <Step6
      v-show="step == 5"
      @toStep="toStep"
      @back="back"
      @changeVariant="changeVariant"
    />
    <Step7
      v-show="step == 6"
      @toStep="toStep"
      :variant="variant"
      @repeat="$emit('repeat')"
    />
  </div>
</template>

<script>
import Step1 from "@/components/laldICC/Step1.vue";
import Step2 from "@/components/laldICC/Step2.vue";
import Step3 from "@/components/laldICC/Step3.vue";
import Step4 from "@/components/laldICC/Step4.vue";
import Step5 from "@/components/laldICC/Step5.vue";
import Step6 from "@/components/laldICC/Step6.vue";
import Step7 from "@/components/laldICC/Step7.vue";

export default {
  name: "Steps",
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
    Step7,
  },
  data: () => ({
    step: 0,
    stepsList: [],
    variant: null,
    visitedSteps: [],
  }),
  methods: {
    toStep(step) {
      this.stepsList.push(this.step);
      this.step = step;
      if (!this.visitedSteps.includes(this.step)) {
        this.visitedSteps.push(this.step);
      }
    },
    back() {
      this.step = this.stepsList[this.stepsList.length - 1];
      this.stepsList.splice(this.stepsList.length - 1, 1);
    },
    changeVariant(variant) {
      this.variant = variant;
    },
  },
};
</script>

<style lang="scss" scoped>
.lald-case__steps {
  margin-top: 32px;
}
</style>